interface AuthPoolConfig {
  userPoolId: string;
  clientId: string;
  domain: string;
}

export enum Stage {
  beta = "beta",
  prod = "prod"
}

export const AUTH_CONFIG: Record<Stage, AuthPoolConfig> = {
  beta: {
    userPoolId: "us-west-2_X2FXPBifd",
    clientId: "6ldmmju4q9ffqkpddgiq65cjt0",
    domain: "abprograms-console-beta.auth.us-west-2.amazoncognito.com"
  },
  prod: {
    userPoolId: "us-west-2_6Kg9vU4Gq",
    clientId: "4npj6iehf9avcgn1k06sp72suk",
    domain: "abprograms-console-prod.auth.us-west-2.amazoncognito.com"
  }
};

// What the UI region selector knows about (passed by the React app).
export type FrontendRegion = "NA" | "EU" | "FE";

// What corresponds to a deployed API Gateway. Note: EU is intentionally absent —
// EU traffic always resolves to ZAZ (or FRA for DE) before reaching the lookup.
export type BackendRegion = "NA" | "FE" | "ZAZ" | "FRA";

export const API_REGION_FOR_STAGE: Record<Stage, Record<BackendRegion, string>> = {
  beta: {
    NA: "us-west-2",
    FE: "us-west-2",
    ZAZ: "us-west-2",
    FRA: "us-west-2"
  },
  prod: {
    NA: "us-east-1",
    FE: "us-west-2",
    ZAZ: "eu-south-2",
    FRA: "eu-central-1"
  }
};

export const INVOKE_API_ID: Record<Stage, Record<BackendRegion, string>> = {
  beta: {
    NA: "afl1ktdiib",
    FE: "afl1ktdiib",
    ZAZ: "afl1ktdiib",
    FRA: "afl1ktdiib"
  },
  prod: {
    NA: "wx0jjlliga",
    FE: "d7t9gbt9h5",
    ZAZ: "kyr0shxs5d",
    FRA: "h91s0zrzbe"
  }
};
